import { render, staticRenderFns } from "./DimitraModuleAnswer.vue?vue&type=template&id=5f2b6db4&scoped=true"
import script from "./DimitraModuleAnswer.vue?vue&type=script&lang=js"
export * from "./DimitraModuleAnswer.vue?vue&type=script&lang=js"
import style0 from "./DimitraModuleAnswer.vue?vue&type=style&index=0&id=5f2b6db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2b6db4",
  null
  
)

export default component.exports